import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';

function ConfirmEmail() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { supabase, logout } = useAuth();

  useEffect(() => {
    console.log('ConfirmEmail loaded with hash:', location.hash, 'and search:', location.search); // Log for debug

    // Parse hash (primary for client-side)
    const hash = location.hash.substring(1);
    const hashParams = new URLSearchParams(hash);

    // Fallback to query params if hash empty (server-side mode)
    const searchParams = new URLSearchParams(location.search);
    const params = hashParams.size > 0 ? hashParams : searchParams;

    console.log('Parsed params:', Object.fromEntries(params)); // Log full params

    // If no params at all, skip processing (prevents error on non-verification mounts)
    if (params.size === 0) {
      setLoading(false);
      return;
    }

    const type = params.get('type');
    const accessToken = params.get('access_token');
    const refreshToken = params.get('refresh_token');

    if (type === 'email_change') {
      if (accessToken && refreshToken) {
        // Set session for the changed email
        supabase.auth.setSession({ access_token: accessToken, refresh_token: refreshToken })
          .then(({ data, error }) => {
            if (error) {
              console.error('setSession error:', error);
              throw error;
            }
            // Refresh to confirm and log new email
            return supabase.auth.refreshSession();
          })
          .then(({ data, error }) => {
            if (error) throw error;
            console.log('Confirmed new email after session set:', data.user.email); // Debug log
            setSuccess('Email change confirmed! Signing out—redirecting to sign in...');
            logout();
            setTimeout(() => navigate('/signin'), 3000);
          })
          .catch((err) => {
            setError(`Verification failed: ${err.message}. Try again or contact support.`);
            setTimeout(() => navigate('/signin'), 5000);
          });
      } else {
        setError('Missing access or refresh token in the link.');
        setTimeout(() => navigate('/signin'), 5000);
      }
    } else if (params.get('error')) {
      const errorCode = params.get('error_code') || 'unknown';
      const errorDesc = params.get('error_description') || 'Unknown issue.';
      console.error('Verification error:', { code: errorCode, desc: errorDesc });
      setError(`Error: ${errorDesc} (Code: ${errorCode}). Please try changing your email again to get a fresh link.`);
      setTimeout(() => navigate('/signin'), 5000);
    } else {
      setError('Invalid link type or missing verification details.');
      setTimeout(() => navigate('/signin'), 5000);
    }

    setLoading(false);
  }, [location, navigate, supabase, logout]);

  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      <div className="flex-grow p-4">
        <div className="max-w-md mx-auto bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-4 text-center">Confirm Email Change</h2>
          {error && <p className="text-red-500 mb-4 text-center">{error}</p>}
          {success && <p className="text-green-500 mb-4 text-center">{success}</p>}
          {loading && <p className="text-center text-gray-700">Verifying email change...</p>}
        </div>
      </div>
    </div>
  );
}

export default ConfirmEmail;